<template>
  <wujieVue :name="route.meta?.name || 'wujie'" :url="route.meta?.url" :aegis="aegis" />
</template>

<script lang="ts" setup>
import wujieVue from '@tencent/iegsp-common/components/wujie/index.vue';
import { useRoute } from 'vue-router';
import { getAegis } from '@/utils/aegis';

const route = useRoute();
const aegis = getAegis();
</script>
